/* eslint-disable react/prop-types */
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { ReactComponent as TopArrow } from "assets/Icons/topArrow.svg"; // Import as React component
import React from "react";

export default function ScrollTopButton({ onClick }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box>
      {isMobile ? (
        <Button
          variant="contained"
          onClick={onClick}
          sx={{
            width: "50px",
            height: "50px",
            minWidth: "50px",
            padding: 2,
            borderRadius: "50%",
            border: "2px solid #FFF",
            background: "#FCFCFC",
            boxShadow: "0px 14px 30px 0px rgba(0, 0, 0, 0.12)",
            ":hover": {
              border: "2px solid #020A0D",
            },
          }}
        >
          <TopArrow />
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={onClick}
          endIcon={<TopArrow />}
          sx={{
            display: "inline-flex",
            padding: "10px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "30px",
            border: "2px solid #FFF",
            background: "#FCFCFC",
            boxShadow: "0px 14px 30px 0px rgba(0, 0, 0, 0.12)",
            textTransform: "none",
            color: "#555B5D",
            fontFamily: "Inter",
            fontSize: "19px",
            fontWeight: 500,
            lineHeight: 1.4,
            ":hover": {
              border: "2px solid #020A0D",
            },
          }}
        >
          Scroll to Top
        </Button>
      )}
    </Box>
  );
}
